<template>
<!-- 账户认证 -->
  <div class="content">
    <el-row>
      <!-- left -->
      <el-col :span="12">
        <div class="box">
          <span class="box_title">企业认证<span>|</span></span>
          <!-- form -->
          <div class="form">
            <el-form :model="companyForm" :rules="companyRules" ref="companyForm" label-width="180px" class="demo-ruleForm">
              <el-form-item label="企业名称：" prop="companyName">
                <el-input v-model="companyForm.companyName" size="small" placeholder="请输入企业名称"></el-input>
              </el-form-item>
              <el-form-item label="统一社会信用代码：" prop="companyCode">
                <el-input v-model="companyForm.companyCode" size="small" placeholder="请输入统一社会信用代码"></el-input>
              </el-form-item>
              <el-form-item label="法定代表人：" prop="legalName">
                <el-input v-model="companyForm.legalName" size="small" placeholder="请输入法定代表人姓名"></el-input>
              </el-form-item>
              <el-form-item label="法人身份证号：" prop="legalIDCard">
                <el-input v-model="companyForm.legalIDCard" size="small" placeholder="请输入法定代表人姓名"></el-input>
              </el-form-item>
              <el-form-item label="上传法人身份证照片：" prop="legalFIDCardImg" ref="legalFIDCardImg">
                <el-row>
                  <el-col :span="12">
                    <div @click="changeFlag('legalFIDCardImg')" v-loading="legalLoading">
									  	<el-upload 
									  		class="avatar-uploader"
									  		action="string" 
									  		:data="{flag:this.imageFlag}"
									  		:http-request="uploadImg"
                        :show-file-list="false"
									  		:before-upload="beforeUpload">
									  		<img v-if="companyForm.legalFIDCardImg" :src="companyForm.legalFIDCardImg" class="avatar">
                        <i v-else class="el-icon-plus avatar-uploader-icon">人像面</i>
									  	</el-upload>
									  </div>
                  </el-col>
                  <el-col :span="12">
                    <div @click="changeFlag('legalBIDCardImg')">
									  	<el-upload 
									  		class="avatar-uploader"
									  		action="string" 
									  		:data="{flag:this.imageFlag}"
									  		:http-request="uploadImg"
                        :show-file-list="false"
									  		:before-upload="beforeUpload">
									  		<img v-if="companyForm.legalBIDCardImg" :src="companyForm.legalBIDCardImg" class="avatar">
                        <i v-else class="el-icon-plus avatar-uploader-icon">国徽面</i>
									  	</el-upload>
									  </div>
                  </el-col>
                </el-row>
                <div class="tips">
                  请提供证件的原件照片或彩色扫描件正反面（正副本均可），文字清晰可辨认格式要求jpg、jpeg、png，不超过2MB
                </div>
              </el-form-item>
              <el-form-item label="上传企业营业执照照片：" prop="companyLicenseImg" ref="companyLicenseImg">
                <el-row>
                  <el-col :span="12">
                    <div @click="changeFlag('companyLicenseImg')" v-loading="licenseLoading">
									  	<el-upload 
									  		class="avatar-uploader"
									  		action="string" 
									  		:data="{flag:this.imageFlag}"
									  		:http-request="uploadImg"
                        :show-file-list="false"
									  		:before-upload="beforeUpload">
									  		<img v-if="companyForm.companyLicenseImg" :src="companyForm.companyLicenseImg" class="avatar">
                        <i v-else class="el-icon-plus avatar-uploader-icon">营业执照</i>
									  	</el-upload>
									  </div>
                  </el-col>
                </el-row>
                <div class="tips">
                  请提供证件的原件照片或彩色扫描件（正副本均可），文字/盖章清晰可辨认格式要求jpg、jpeg、png，不超过2MB
                </div>
              </el-form-item>
            </el-form>
            <div class="submit_btn" @click="identifyCompany">
              提交
            </div>
          </div>
        </div>
      </el-col>
      <!-- right -->
      <el-col :span="12" style="padding-left:2%">
        <div class="box">
          <span class="box_title">个人认证<span>|</span></span>
          <div class="form">
            <el-form :model="personalForm" :rules="personalRules" ref="personalForm" label-width="180px" class="demo-ruleForm">
              <el-form-item label="真实姓名：" prop="memberName">
                <el-input size="small" v-model="personalForm.memberName" placeholder="请输入登陆人真实姓名"></el-input>
              </el-form-item>
              <el-form-item label="身份证号：" prop="memberIDCard">
                <el-input size="small" v-model="personalForm.memberIDCard" placeholder="请输入登陆人身份证号"></el-input>
              </el-form-item>
              <el-form-item label="上传个人身份证照片：" prop="memberFIDCardImg" ref="memberFIDCardImg">
                <el-row>
                  <el-col :span="12">
                    <div @click="changeFlag('memberFIDCardImg')" v-loading="personalLoading">
									  	<el-upload 
									  		class="avatar-uploader"
									  		action="string" 
									  		:data="{flag:this.imageFlag}"
									  		:http-request="uploadImg"
                        :show-file-list="false"
									  		:before-upload="beforeUpload">
									  		<img v-if="personalForm.memberFIDCardImg" :src="personalForm.memberFIDCardImg" class="avatar">
                        <i v-else class="el-icon-plus avatar-uploader-icon">人像面</i>
									  	</el-upload>
									  </div>
                  </el-col>
                  <el-col :span="12">
                    <div @click="changeFlag('memberBIDCardImg')">
									  	<el-upload 
									  		class="avatar-uploader"
									  		action="string" 
									  		:data="{flag:this.imageFlag}"
									  		:http-request="uploadImg"
                        :show-file-list="false"
									  		:before-upload="beforeUpload">
									  		<img v-if="personalForm.memberBIDCardImg" :src="personalForm.memberBIDCardImg" class="avatar">
                        <i v-else class="el-icon-plus avatar-uploader-icon">国徽面</i>
									  	</el-upload>
									  </div>
                  </el-col>
                </el-row>
                <div class="tips">
                  请提供证件的原件照片或彩色扫描件正反面（正副本均可），文字清晰可辨认格式要求jpg、jpeg、png，不超过2MB
                </div>
              </el-form-item>
            </el-form>
            <div class="submit_btn" @click="identifyPerson">
              提交
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { obsUploadImage, identifyIDCard, identifyLicense } from '@/api/resource.js'
import { identifyCompany, identifyPerson } from '@/api/console/accountCenter.js'
import token from '@/utils/token.js'
export default {
  data() {
    return {
      companyForm: {
        companyName: '',
        companyCode: '',
        legalName: '',
        legalIDCard: '',
        companyStatus: '0',
        legalFIDCardImg: '',//法人身份证
        legalBIDCardImg: '',
        companyLicenseImg: '',//企业营业执照
      },
      companyLegalState: '0',//企业法人认证状态
			companyState: '0',//企业营业执照认证状态
      companyRules: {
        companyName: [
          { required: true, message: '请输入企业名称', trigger: 'blur' },
        ],
        companyCode: [
          { required: true, message: '请输入统一社会信用代码', trigger: 'blur' },
        ],
        legalName: [
          { required: true, message: '请输入法定代表人', trigger: 'blur' },
        ],
        legalIDCard: [
          { required: true, message: '请输入法人身份证号', trigger: 'blur' },
          {
            pattern: /(^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$)|(^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{2}$)/,
            message: '证件号码格式有误！',
            trigger: 'blur'
          }
        ],
        legalFIDCardImg: [
					{ required: true, message: '请上传法人身份证照片', trigger: 'change'}
				],
        companyLicenseImg: [
					{ required: true, message: '请上传企业营业执照', trigger: 'change'}
				],
      },
      imageFlag: '',
      // 法人身份证正面
      legalLoading: false,
      //营业执照
      licenseLoading: false,
      // 个人
      personalForm: {
        memberName: '',
        memberIDCard: '',
        personStatus: '0',//个人认证状态
        memberFIDCardImg: '',//个人身份证
        memberBIDCardImg: '',
      },
      loading: true,
      personalRules: {
        memberName: [
          { required: true, message: '请输入真实姓名', trigger: 'blur' },
        ],
        memberIDCard: [
          { required: true, message: '请输入身份证号', trigger: 'blur' },
          {
            pattern: /(^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$)|(^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{2}$)/,
            message: '证件号码格式有误！',
            trigger: 'blur'
          }
        ],
        memberFIDCardImg: [
					{ required: true, message: '请上传个人身份证照片', trigger: 'change'}
				],
      },
      //个人身份证正面
      personalLoading: false,
    }
  },
  methods: {
    //上传之前的验证
    beforeUpload(file) {
      const isIMAGE =  (file.type === 'image/jpg') || (file.type === 'image/png') || (file.type === 'image/jpeg')
				const isLt2M = file.size / 1024 / 1024 < 2;
				if (!isIMAGE) {
					this.$message.error('上传文件只能是图片格式!')
				}
				if (!isLt2M) {
				  this.$message.error('上传图片大小不能超过 2MB!');
				}
				return isIMAGE && isLt2M;
    },
    changeFlag(val) {
			this.imageFlag = val;
		},
    //上传图片
    uploadImg(param) {
			let flag = param.data.flag
      //图片加载
      if(flag == 'legalFIDCardImg') {
        this.legalLoading = true;
      } else if(flag == 'companyLicenseImg') {
        this.licenseLoading = true;
      } else if(flag == 'memberFIDCardImg') {
        this.personalLoading = true;
      }
      //图片上传、认证
			let formData = new FormData();
			formData.append("file", param.file)
			obsUploadImage(formData).then(data => {
				if(flag == 'legalFIDCardImg'){
					this.companyForm.legalFIDCardImg = data.data
          this.$refs.legalFIDCardImg.clearValidate();//清除验证规则
          this.identifyIDCard(this.companyForm.legalFIDCardImg, 1);
				}else if(flag == 'legalBIDCardImg'){
					this.companyForm.legalBIDCardImg = data.data
				}else if(flag == 'companyLicenseImg'){
					this.companyForm.companyLicenseImg = data.data
          this.$refs.companyLicenseImg.clearValidate();//清除验证规则
          this.identifyLicense(this.companyForm.companyLicenseImg);
				}else if(flag == 'memberFIDCardImg'){
					this.personalForm.memberFIDCardImg = data.data
          this.$refs.memberFIDCardImg.clearValidate();//清除验证规则
          this.identifyIDCard(this.personalForm.memberFIDCardImg, 0);
				}else if(flag == 'memberBIDCardImg'){
					this.personalForm.memberBIDCardImg = data.data
				}
			}).catch(error => {
				this.$message.error(error)
			})
		},
    //身份证信息认证
		identifyIDCard(cardImgUrl, type) {
			let memberFIDCardImg = cardImgUrl;
			if(type == 0) {
				//个人认证
				let memberIDCard = this.personalForm.memberIDCard;
				let memberName = this.personalForm.memberName;
				identifyIDCard(memberFIDCardImg, memberIDCard, memberName).then(res => {
					// console.log('个人身份证信息认证--', res);
					if(res.data) {
						this.personalForm.personStatus = '2';
					} else {
						this.personalForm.personStatus = '1';
					}
          this.personalLoading = false;//图片加载
				})
			} else {
				//企业法人认证
				let memberIDCard = this.companyForm.legalIDCard;
				let memberName = this.companyForm.legalName;
				identifyIDCard(memberFIDCardImg, memberIDCard, memberName).then(res => {
					// console.log('法人身份证信息认证--', res);
					if(res.data) {
						this.companyLegalState = '2'
						if(this.companyState == '2') {
							this.companyForm.companyStatus = '2'
						} else if(this.companyState == '1') {
              this.companyForm.companyStatus = '1'
            } else {
              this.companyForm.companyStatus = '0'
            }
					} else {
						this.companyLegalState = '1'
						if(this.companyState == '0') {
							this.companyForm.companyStatus = '0'
						} else {
							this.companyForm.companyStatus = '1'
						}
					}
          this.legalLoading = false;//图片加载
				})
			}
		},
      //营业执照信息认证
		identifyLicense(cardImgUrl) {
			let LicenseImg = cardImgUrl;
			let companyCode = this.companyForm.companyCode;
			let companyName = this.companyForm.companyName;
			let legalName = this.companyForm.legalName;
			identifyLicense(LicenseImg,companyCode,companyName,legalName).then(res => {
				// console.log('营业执照信息认证--', res);
				if(res.data) {
					this.companyState = '2'
					if(this.companyLegalState == '2') {
						this.companyForm.companyStatus = '2'
					} else if(this.companyLegalState == '1') {
            this.companyForm.companyStatus = '1'
          } else {
            this.companyForm.companyStatus = '0'
          }
				} else {
					this.companyState = '1'
					if(this.companyLegalState == '0') {
						this.companyForm.companyStatus = '0'
					} else {
						this.companyForm.companyStatus = '1'
					}
				}
        this.licenseLoading = false;
			})
		},
    //企业认证
    identifyCompany() {
      this.$refs['companyForm'].validate((valid) => {
        if (valid) {
          let param = {
            ...this.companyForm,
            username: token.getUser().username,
            id: token.getUser().id,
          }
          identifyCompany(param).then(res=> {
            this.$message.success('企业认证提交成功！');
            // location.reload();
            this.$router.push({path: '/accountCenter',query:{index: 0}});
          })
        } else {
          return false;
        }
      })
      
    },
    //个人认证
    identifyPerson() {
      this.$refs['personalForm'].validate((valid) => {
        if (valid) {
          let param = {
            ...this.personalForm,
            username: token.getUser().username,
            id: token.getUser().id,
          }
          identifyPerson(param).then(res => {
            this.$message.success('个人认证提交成功！');
            this.$router.push({path: '/accountCenter',query:{index: 0}});
          })
        } else {
          return false;
        }
      })
    },
  }
}
</script>

<style lang="scss" scoped="scoped">
.content {
  .box {
    position: relative;
    padding: 20px 0 70px;
    margin-top: 20px;
    border: 1px solid #E5E5E5;
    .box_title {
      margin-left: 20px;
      color: #5783EE;
      span {
        margin-left: 20px;
        font-weight: 600;
      }
    }
    .form {
      width: 80%;
      margin-top: 20px;
      .tips {
        margin-top: 10px;
        font-size: 12px;
        color: #808080;
        line-height: 18px;
      }
    }
    .submit_btn {
      position: absolute;
      bottom: 0;
      right: 0;
      width: 132px;
      height: 32px;
      background-color: #537EEE;
      font-size: 14px;
      color: #fff;
      text-align: center;
      line-height: 32px;
    }
    .submit_btn:hover {
      cursor: pointer;
    }
  }
}
</style>

<style lang="scss">
.disabled .el-upload--picture-card{
  display: none;
}
.avatar-uploader .el-upload {
    border: 1px dashed #c0ccda;
    border-radius: 6px;
    background-color: #fbfdff;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #537EEE;
  }
  .avatar-uploader-icon {
    font-size: 14px;
    color: #8c939d;
    width: 124px;
    height: 124px;
    line-height: 124px;
    text-align: center;
  }
  .avatar {
    width: 124px;
    height: 124px;
    display: block;
  }
</style>